import { BrowserRouter, Routes, Route } from 'react-router-dom'

import Redirect from 'components/Redirect'
import Radar from 'sections/Radar'
import Info from 'sections/Info'
import Map from 'sections/Map'

const Ro = () => {

  return <BrowserRouter>
    <Routes>
      <Route path="info" Component={ Info } />

      <Route path="map" Component={ Map } />

      <Route path="radar" Component={ Radar } />

      <Route
        index
        element={ <Redirect to="/info" /> }
      />

      <Route
        path="*"
        element={ <Redirect to="/info" /> }
      />

    </Routes>
  </BrowserRouter>
}

export default Ro
